/**
 * Blog overview tags (sections/main-blog.liquid): on mobile the "Filteren" button opens the tag list as a
 * drawer from the left (html.bx-tags-open), like the collection filters; desktop shows it as a sidebar with
 * a "Toon meer" toggle for the tags beyond the first few.
 */
export function initBlogTags() {
  const panel = document.getElementById('bx-blog-tags');
  if (!panel) return;

  const html = document.documentElement;
  const openers = document.querySelectorAll('[data-bx-tags-open]');

  const setOpen = (open) => {
    html.classList.toggle('bx-tags-open', open);
    openers.forEach((el) => el.setAttribute('aria-expanded', String(open)));
  };

  openers.forEach((el) =>
    el.addEventListener('click', (event) => {
      event.preventDefault();
      setOpen(!html.classList.contains('bx-tags-open'));
    })
  );

  document.querySelectorAll('[data-bx-tags-close]').forEach((el) =>
    el.addEventListener('click', () => setOpen(false))
  );

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && html.classList.contains('bx-tags-open')) {
      setOpen(false);
      openers[0]?.focus();
    }
  });

  panel.querySelector('[data-bx-tags-more]')?.addEventListener('click', (event) => {
    const expanded = panel.classList.toggle('is-expanded');
    event.currentTarget.setAttribute('aria-expanded', String(expanded));
  });
}
